/*

	Lilact
	Copyright (C) 2024-2026 Arash Kazemi <contact.arash.kazemi@gmail.com>
	All rights reserved.

	BSD-2-Clause

	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are met:

	* Redistributions of source code must retain the above copyright
		notice, this list of conditions and the following disclaimer.
	* Redistributions in binary form must reproduce the above copyright
		notice, this list of conditions and the following disclaimer in the
		documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

*/


export const [ 	
				LOCATION,

				CORE,
				COMPONENT,
				TEXT,
				IS_ZOMBIE,
				IDX,
				CHILD_CLASS_ADDENDUM,
				MEMOIZED,
				LAZY,
				CLONED_STYLE,

				DUE,
				REPEAT,
				CLEARED,
				INTERVAL,
				CALLBACK,
				ARGS
			] = 
			[
				Symbol.for('LILACT:LOCATION'),
				
				Symbol.for('LILACT:CORE'),
				Symbol.for('LILACT:COMPONENT'),
				Symbol.for('LILACT:TEXT'),
				Symbol.for('LILACT:IS_ZOMBIE'),
				Symbol.for('LILACT:IDX'),
				Symbol.for('LILACT:CHILD_CLASS_ADDENDUM'),
				Symbol.for('LILACT:MEMOIZED'),
				Symbol.for('LILACT:LAZY'),
				Symbol.for('LILACT:CLONED_STYLE'),

				Symbol.for('LILACT:TIMERS:DUE'),
				Symbol.for('LILACT:TIMERS:REPEAT'),
				Symbol.for('LILACT:TIMERS:CLEARED'),
				Symbol.for('LILACT:TIMERS:INTERVAL'),
				Symbol.for('LILACT:TIMERS:CALLBACK'),
				Symbol.for('LILACT:TIMERS:ARGS')
			];
